// extracted by mini-css-extract-plugin
export default {"GoBack":"ForgotPwdForm_GoBack__NvfRR","backLogin":"ForgotPwdForm_backLogin__Z54Ga"};